;(function () {
  angular
    .module('contrast.server.settings')
    .controller(
      'ModalServerCleanupConfirmationInstanceCtrl',
      ModalServerCleanupConfirmationInstanceCtrl
    )

  function ModalServerCleanupConfirmationInstanceCtrl(
    $scope,
    $uibModalInstance
  ) {
    'ngInject'

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel')
    }

    $scope.ok = function () {
      $uibModalInstance.close()
    }
  }
})()
